import React, { useState, ChangeEvent, useContext, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom'

import FullLogo from '../assets/full-logo.svg';

import UserContext from '../context/UserContext';
import { userLogIn, userLogOut } from '../helpers/AuthUserHelper';
import GetUserLoginRedirectLink from '../helpers/GetUserLoginRedirectLink';
import Spinner from '../components/Spinner';
import OwnerFooter from '../components/OwnerFooter';
import { ErrorDanish } from '../helpers/ErrorDanish';
import { UserLoginStatus } from '../helpers/EnumsInternal';
import MainErrorText from '../components/MainErrorText';
import { ApiHttpServiceAnon } from '../services/ApiServices';

function LoginPage() {
    const userLoginObject = useContext(UserContext);
    const history = useHistory();
    const [ isClearUser, setIsClearUser ] = useState<boolean>(false);
    const [loginName, setLoginName] = useState<string>('');
    const [loginPwd, setLoginPwd] = useState<string>('');
    const [spinner, showSpinner] = useState<boolean>(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(true);
    const [errorText, setErrorText] = useState<string>('');


    useEffect(() => {
        if (!isClearUser)
            userLogOut(userLoginObject.setLoginUser);
            setIsClearUser(true);
    }, [ isClearUser, userLoginObject.setLoginUser ]);


    function onLoginNameInputFieldChange(inputName: string) {
        setLoginName(inputName);

        if (inputName && loginPwd)
            setIsButtonDisabled(false);
        else
            setIsButtonDisabled(true);
    }

    function onLoginPwdInputFieldChange(inputCode: string) {
        setLoginPwd(inputCode);

        if (inputCode && loginName)
            setIsButtonDisabled(false);
        else
            setIsButtonDisabled(true);
    }


    async function handleLoginClick() {
        showSpinner(true);
        setIsButtonDisabled(true);
        setLoginPwd('');
        setErrorText('');

        if (loginName === '' || loginPwd === '') {
            setErrorText(ErrorDanish["LoginUserAndPwdEmpty"]);
            setIsButtonDisabled(false);
            showSpinner(false);
        }

        else {
            await ApiHttpServiceAnon('users/auth', 'POST', {LoginName:loginName, LoginPwd:loginPwd })
            .then(result => {
                if (!result) {
                    setErrorText(ErrorDanish["GeneralError"]);
                } else {
                    switch(result.status) {
                        case 200: // OK
                            result.json()
                            .then(resultJson => {
                                // Generic write error.
                                if (!resultJson) {
                                    setErrorText(ErrorDanish["DbFetchDataError"]);
                                // Success.
                                } else {
                                    switch (resultJson.loginStatus) {
                                        case UserLoginStatus.UnknownUser:
                                            setErrorText(ErrorDanish["UnknownUser"]);
                                            break;
                                        case UserLoginStatus.InvalidPwd:
                                            setErrorText(ErrorDanish["LoginInvalidPwd"]);
                                            break;
                                        case UserLoginStatus.NoMoreAttempts:
                                            setErrorText(ErrorDanish["LoginNoMoreAttempts"]);
                                            break;
                                        case UserLoginStatus.NotActive:
                                            setErrorText(ErrorDanish["LoginUserNotActive"]);
                                            break;
            
                                        case UserLoginStatus.Success:
                                            const tmpUserLoginObject =                                            
                                            {
                                                "appUserId": resultJson.appUserId,
                                                "userType": resultJson.userType,
                                                "loginName": resultJson.loginName,
                                                "stakeholderId": resultJson.stakeholderId,
                                                "stakeholder": resultJson.stakeholder,
                                                "logoFileName": resultJson.logoFileName,
                                                "stakeholderType": resultJson.stakeholderType,
                                                "firstname": resultJson.firstname,
                                                "lastname": resultJson.lastname,
                                                "email": resultJson.email,
                                                "phone": resultJson.phone,
                                                "logInDateTime": resultJson.logInDateTime,
                                                "token": resultJson.token,
                                                "refreshToken": resultJson.refreshToken,
                                                "refreshTokenExpiry": resultJson.refreshTokenExpiry
                                            };

                                            showSpinner(false);
                                            userLoginObject.setLoginUser(tmpUserLoginObject);            
                                            userLogIn(tmpUserLoginObject);
                                            history.push(GetUserLoginRedirectLink(resultJson.changePwdNextLoginPrompt, resultJson.userType, resultJson.stakeholderType));

                                            return;
            
                                        case UserLoginStatus.DbError:
                                        default:
                                            setErrorText(ErrorDanish["GeneralError"]);
                                            break;
                                    }
                                }
                             });
                        break;
                        case 400:   // Bad Request
                        default:
                            setErrorText(ErrorDanish["DbFetchDataError"]);
                            break;
                    }
                }
    
                showSpinner(false);
            })
            .catch(e => {
                console.log("Something fishy happened: " + e);
                setErrorText(ErrorDanish["DbConxError"]);
                showSpinner(false);
            });
        }
    }

    return (
        <div className="login-container login-admin">
            { spinner && <Spinner /> }
            <div className="content">
                <div className="top d-flex align-items-center justify-content-between">
                    <Link className="logo" to="/"><img src={FullLogo} alt="Logo" /></Link>
                </div>
                <div className="login-area">
                    <div className="inner">
                        <h1>Admin login</h1>
                        <p>Log ind herunder hvis du er Advertiser, Supplier eller Processor, for at tilg&aring; din administrative tilgang.</p>
                        <form onSubmit={ e => e.preventDefault() }>
                            <div className="input-container">
                                <input id="UserNameValue" type="text" maxLength={40} autoFocus value={loginName}
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => onLoginNameInputFieldChange(e.target.value)}></input>
                                <label htmlFor="UserNameValue">Brugernavn</label>
                            </div>
                            <div className="input-container">
                                <input id="UserPwdValue" type="password" maxLength={30} value={loginPwd}
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => onLoginPwdInputFieldChange(e.target.value)}></input>
                                <label htmlFor="UserPwdValue">Adgangskode</label>
                            </div>
                            { errorText !== '' && <MainErrorText errorText={errorText} /> }
                            <button type="submit" className="btn" disabled={ isButtonDisabled }
                                onClick={() => handleLoginClick()}>Log ind</button>
                        </form>
                    </div>
                </div>

                <OwnerFooter />
            </div>
            <div className="image-container"></div>
        </div>
    );
}

export default LoginPage
